import { render, staticRenderFns } from "./ReportShare.vue?vue&type=template&id=a38b3ed2&scoped=true"
import script from "./ReportShare.vue?vue&type=script&lang=js"
export * from "./ReportShare.vue?vue&type=script&lang=js"
import style0 from "./ReportShare.vue?vue&type=style&index=0&id=a38b3ed2&prod&scoped=true&lang=scss"
import style1 from "./ReportShare.vue?vue&type=style&index=1&id=a38b3ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b3ed2",
  null
  
)

export default component.exports